export const openBlankTab = () => window.open("about:blank", "_blank");

export const setNewTabLocation = (newTab, url) => {
  if (!newTab || !url) return false;

  newTab.location.href = url;
  return true;
};

export const openInNewTab = (url) => {
  const newTab = openBlankTab();
  setNewTabLocation(newTab, url);
  return newTab;
};
